import _ from 'lodash'

export const canFromPermissions = (permissions: string[]) => (permission: string) => {
  return _.includes(permissions, permission)
}
